// Final match summary, computed identically on the server (when saving) and on the device.

import type { GuessResult } from "./api";
import { ranking, type ClockState } from "./clock";

export function buildGuessResult(players: { name: string; avatar: number; guest: boolean }[], s: ClockState, shown: number): GuessResult {
  const order = ranking(s);
  return {
    winner: s.endedBy === "abort" ? null : s.winner,
    endedBy: s.endedBy,
    durationMs: s.startedAt !== null && s.endedAt !== null ? Math.max(0, s.endedAt - s.startedAt) : 0,
    pictures: shown,
    players: s.players.map((p, i) => ({
      name: players[i]?.name ?? `#${i + 1}`,
      avatar: players[i]?.avatar ?? 0,
      guest: players[i]?.guest ?? true,
      remaining: p.remaining,
      out: p.out,
      correct: p.correct,
      wrong: p.wrong,
      skips: p.skips,
      unclear: p.unclear,
      avgThinkMs: p.correct ? Math.round(p.thinkMs / p.correct) : null,
      rank: order.indexOf(i) + 1,
    })),
  };
}
